<template>
	<div class="loader">
		<div class="loader__bar" :class="{ 'active': active }" :style="{
			'width': width +'%'
		}"></div>
	</div>
</template>
<script>
	import Vue from 'vue';
	import Vuex from 'vuex';

	export default {
		name: 'loading-bar',
		data() {
			return {
				refreshRate: 500,
				interval: null,
				active: false,
				max: 0,
				width: 0
			}
		},
		computed: {
			...Vuex.mapState([
				'lang',
				'loaderList',
			])
		},
		watch: {
			loaderList: function (list) {
				if (list.length > 0) {
					this.max++;
				}

				if (list.length > 0 && this.interval === null) {

					this.startMonitor();

				} else if (list.length === 0 && this.interval !== null) {
					this.stopMonitor();
				}
			}
		},
		mounted() {

		},
		methods: {

			startMonitor() {
				this.interval = setInterval(this.loadMonitor, this.refreshRate);
				this.active = true;
			},
			stopMonitor() {
				//Fill load bar full
				this.width = 100;

				//Wait until full abr
				clearInterval(this.interval);
				this.interval = null;
				setTimeout(() => {
					//Clerar all
					this.max = 0;
					this.width = 0;
					this.active = false;


				}, this.refreshRate + 100);


			},

			loadMonitor() {

				let tmp = this.width + 3;

				this.width = ((this.loaderList.length ^ this.max) * 0.1 + 0.3) * 100;

				if (this.width < tmp && tmp < 80) {
					this.width = tmp;
				} else if (this.width < tmp) {
					this.width = 80;
				}

			}
		}
	}


</script>
<style lang="scss">
	@import "./src/scss/components/loader";

</style>

